import React, { Component } from 'react';
import { HotKeys } from "@platform/base";
const booleanType = ['switch', 'checkbox_switch', 'switch_browse'];

export default function toExcel(Table) {
    return class TableToExcel extends Component {
        constructor(props) {
            super(props);
        }

        //将数型模板 转换为数组模板
        formatMeta = metaItems => {
            let arrayMeta = [];

            function TraverNode(nodes) {
                if (Array.isArray(nodes)) {
                    nodes.map(item => {
                        //只存叶子节点
                        if (item.visible && !Array.isArray(item.children) || (Array.isArray(item.children) && item.children.length < 1)) {
                            if (item.attrcode !== 'checkbox' && item.attrcode !== 'numberindex') {
                                arrayMeta.push(item);
                            }
                        }
                        TraverNode(item.children);
                    });
                }
            }

            TraverNode(metaItems);

            return arrayMeta;
        }

        formatTable = () => {
            let { columns, data } = this.props;

            let metaItems = columns || [];
            var tableBodyHtml = '<table border="1">';
            var tableHeaderHtml = '<table border="1"><tr>';

            let arrayMeta = this.formatMeta(metaItems);
            let hasHeader = false;

            data.forEach(ele => {
                // 获取已选的数据
                var tr = '<tr>';
                let rowData = ele.values || ele;
                if (!hasHeader) {
                    arrayMeta.forEach(item => {
                        if (item.visible && !!item.label) {
                            tr = tr + this.addTd(rowData, item);
                            tableHeaderHtml = tableHeaderHtml + '<td>' + item.label + '</td>';
                        }
                    });
                    hasHeader = true;
                } else {
                    arrayMeta.forEach(item => {
                        if (item.visible && !!item.label) {
                            tr = tr + this.addTd(rowData, item);
                        }
                    });
                }

                tr = tr + '</tr>';
                tableBodyHtml = tableBodyHtml + tr;
            });

            tableHeaderHtml = tableHeaderHtml + '</tr></table>';
            tableBodyHtml = tableBodyHtml + '</table>';

            var html = "<html><head><meta charset='utf-8' /></head><body>" +
                tableHeaderHtml +
                tableBodyHtml +
                '</body></html>';

            return html;
        }

        addTd = (rowData, item) => {
            let tdVal = '';
            let itemVal = rowData[item.attrcode];
            if (itemVal && (itemVal.display || itemVal.value)) {
                tdVal = itemVal.display || itemVal.value;
            }
            if (booleanType.includes(item.itemtype) && itemVal && typeof itemVal.value === 'boolean') {
                tdVal = itemVal.value ? '是' : '否';
            }
            return '<td style="mso-number-format:\'\@\';">' + tdVal + '</td>';
        }

        // 导出处理
        handelToExcel = () => {
            //alert("表格数据")
            let { excelName = '导出表格数据' } = this.props;
            let name = excelName;
            let excelHtml = this.formatTable();
            // 实例化一个Blob对象，其构造函数的第一个参数是包含文件内容的数组，第二个参数是包含文件类型属性的对象
            let blob = new Blob([excelHtml], { type: 'application/vnd.ms-excel' });
            let aLink = document.createElement('a');
            // 利用URL.createObjectURL()方法为a元素生成blob URL
            aLink.href = URL.createObjectURL(blob);
            // 设置文件名，目前只有Chrome和FireFox支持此属性
            aLink.download = `${name}.xls`;
            aLink.click();
        };

        render() {
            const { hotkey = 'ctrl+shift+o', isHotkeyToExport } = this.props;
            if (isHotkeyToExport) {
                return <HotKeys
                    keyMap={{ handelToExcel: hotkey }}
                    focused={true}
                    enabled={true}
                    attach={document.body}
                    handlers={{ handelToExcel: this.handelToExcel }}
                >
                    <Table
                        {...this.props}
                    />
                </HotKeys>;
            } else {
                return <Table
                    {...this.props}
                />;
            }
        }
    };
}
